import { Grid, Typography, Button } from "@mui/material";
import EditCalendarOutlinedIcon from "@mui/icons-material/EditCalendarOutlined";
import { AppContext } from "../../../../context/appContext";
import React from "react";

const WelcomeTextWrapper = (): React.JSX.Element => {
  const {
    openLoginDialog,
    setOpenLoginDialog,
    user,
  }: {
    openLoginDialog: boolean;
    setOpenLoginDialog: (open: boolean) => void;
    user: { sessionId: string | null };
  } = React.useContext(AppContext);

  return (
    <Grid item lg={7}>
      <Typography variant="body1" component="p" sx={{ mb: 2 }}>
        Ein entscheidender Baustein, um im Bewerbungsprozess punkten zu können,
        sind aktuelle, zielführende und aussagekräftige Bewerbungsunterlagen und
        Souveränität und Sicherheit im Vorstellungsgespräch.
      </Typography>

      <Typography variant="body1" component="p" sx={{ mb: 2 }}>
        In diesem Portal erhältst du als Teilnehmer:in der WBS Training
        vielfältige Informationen rund um die Themen der Bewerbung und kannst
        zudem bis zu drei für dich kostenfreie Einzelcoachingtermine mit einem
        unserer Onlinebewerbungscoaches buchen.
      </Typography>

      <Typography variant="h5" component="h5" sx={{ mb: 2 }}>
        Durch Einzelcoaching noch sicherer werden.
      </Typography>

      <Typography variant="body1" component="p" sx={{ mb: 2 }}>
        Registriere dich noch heute und buche deine persönlichen
        Onlinebewerbungscoaching-Termine direkt über dieses Portal
      </Typography>

      <Grid container spacing={2}>
        {!user.sessionId && (
          <Grid item xs={12} sm={6}>
            <Button
              variant="outlined"
              color="inherit"
              fullWidth
              sx={{
                mt: 2,
                px: 5,
                py: 1,
                textTransform: "none",
                fontSize: "1rem",
                fontWeight: "bold",
              }}
              onClick={() => setOpenLoginDialog(!openLoginDialog)}
            >
              Zur Anmeldung
            </Button>
          </Grid>
        )}

        <Grid item xs={12} sm={6}>
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            sx={{
              mt: 2,
              px: 5,
              py: 1,
              textTransform: "none",
              fontSize: "1rem",
              fontWeight: "bold",
            }}
            startIcon={<EditCalendarOutlinedIcon />}
            onClick={() => {
              const element = document.getElementById("registration");
              element?.scrollIntoView({ behavior: "smooth" });
            }}
          >
            zur Registrierung
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default WelcomeTextWrapper;
